<template>
    <div class="padded project-charter">
        <h3 class="display-6">Project Charter</h3>
        <todo-list title="Risks" setname="Risks" titleClass="display-7"/>
        <todo-list title="Needs" setname="NeedsCharter"  titleClass="display-7"/>
        <todo-list title="Constraints" setname="Constraints" titleClass="display-7" />
        <todo-list title="Quality" setname="Quality" titleClass="display-7" />
        <todo-list title="Steps" setname="Steps" titleClass="display-7" />
        <todo-list title="Assumptions" setname="Assumptions" titleClass="display-7" />
    </div>
</template>

<script>
    import TodoList from "../todo/TodoList.vue";

    export default {
        components: {
            TodoList
        },
        data: function(){
            return{
            }
        }
    }
</script>

<style lang="scss">
.project-charter{
    > div{
        margin-top: 3rem;

        .display-7{
            margin-bottom: .5rem;
        }
    }

    .todolist{
        color: $muted;
    }
}
</style>
